import React, { Component } from 'react';

import { Form, Radio } from 'antd';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;

class Gender extends Component {
    constructor(props) {
        super(props);

        this.state = {
            gender: +props.value
        };
    }

    handleChange(data) {
        this.setState({
            gender: data.sex
        });

        if(this.props.handleChange) {
            this.props.handleChange(data);
        }
    }

    componentWillReceiveProps(nextProps) {
        if(nextProps.hasOwnProperty('value')) {
            this.setState({
                gender: +nextProps.value
            });
        }
    }

    render() {
        const {gender} = this.state;
        return (
            <FormItem label="性别">
                <RadioGroup
                    value={gender}
                    onChange={(event) => {
                        const sex = event.target.value;
                        this.handleChange({sex});
                    }}
                    >
                    <Radio value={1}>男</Radio>
                    <Radio value={2}>女</Radio>
                </RadioGroup>
            </FormItem>
        );
    }
}

export default Gender;